import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { OfferService } from '../../services/offer.service';

import { AuthGuard } from '../../services/auth/auth.guard';

@Injectable()
export class OfferListResolve implements Resolve<any> {
  constructor(private offerService: OfferService, private authGuard: AuthGuard) {}

  resolve(route: ActivatedRouteSnapshot): void {}
}
